const getAddPetFormOpenType = (view: number, pet: number) => {
    const addPetFormTypes = [
        'topline',
        'tealWidget',
        'twoSquaresWidget',
        'twoSidePetsWidget',
        pet === 1 ? 'dogWidget' : 'catWidget',
    ];
    return addPetFormTypes[view] || 'else';
};
export default getAddPetFormOpenType;
